import { Configuration, OpenAIApi } from 'openai';

const configuration = new Configuration({
  apiKey: process.env.REACT_APP_OPEN_AI_KEY, // Use the correct environment variable for your React app
});

const openai = new OpenAIApi(configuration);

export default openai;